import { supabase } from "@/integrations/supabase/client";

export interface ActivityLog {
  id: string;
  workspace_id: string;
  user_id: string;
  activity_type: string;
  entity_type: string;
  entity_id: string | null;
  metadata: any;
  created_at: string;
  profiles: {
    id: string;
    name: string | null;
    email: string;
  };
}

export interface ActivityLogsFilters {
  activityTypes?: string[];
  dateFrom?: string;
  dateTo?: string;
}

export async function getActivityLogs(
  workspaceId: string,
  filters?: ActivityLogsFilters
): Promise<ActivityLog[]> {
  let query = supabase
    .from('activity_logs')
    .select(`
      id,
      workspace_id,
      user_id,
      activity_type,
      entity_type,
      entity_id,
      metadata,
      created_at,
      profiles (
        id,
        name,
        email
      )
    `)
    .eq('workspace_id', workspaceId)
    .order('created_at', { ascending: false })
    .limit(100);

  // Apply filters
  if (filters?.activityTypes && filters.activityTypes.length > 0) {
    query = query.in('activity_type', filters.activityTypes);
  }

  if (filters?.dateFrom) {
    query = query.gte('created_at', filters.dateFrom);
  }

  if (filters?.dateTo) {
    query = query.lte('created_at', filters.dateTo);
  }

  const { data, error } = await query;

  if (error) throw error;
  return data as ActivityLog[];
}
